module.exports = "<div class=\"block-title\">\n    <h2 [class.bg-danger]=\"readonly\">\n        <strong>{{ getDocumentLabel() }}</strong> &nbsp; {{ getDocumentId() }}\n\n        <span *ngIf=\"readonly\"\n              class=\"bg-danger\">READONLY, locked by: {{ userName }}</span>\n    </h2>\n\n    <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/nv-block-header/nv-block-header.component.html
// module id = ../../../../../src/app/components/nv-block-header/nv-block-header.component.html
// module chunks = 0